import { emailOTPClient, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

import { env } from '@/env'

export const authClient = createAuthClient({
  baseURL: env.VITE_API_URL,
  basePath: '/api/v1/auth',
  plugins: [organizationClient(), emailOTPClient()],
})
